
<div class="container-fluid common-pages-banner">
	<div class="container">
		<div class="tg-theme-heading">
			<h4>Careers with Us</h4>
		</div>
	</div>
</div>

<div class="container-fluid paddEqual bgGray">
	<div class="container">
		<div class="row">
            <div class="col-md-9 col-12">
                <app-matloader *ngIf="loader"></app-matloader>
                <h4 *ngIf="errorMsg">{{errorMsg}}</h4>
                <div id="accordion"  *ngIf="careerList.length>0">
                    <div class="card" *ngFor="let career of careerList;let i=index">
                        <div class="card-header">
                            <a class="card-link" [ngClass]="{'collapsed':i!=0}" data-toggle="collapse" href="#collapse-{{i}}">
                                {{career.title | titlecase}}
                            </a>
                        </div>
                        <div id="collapse-{{i}}" class="collapse"  [ngClass]="{'show':i==0 }"data-parent="#accordion">
                            <div class="card-body" [innerHtml]="career.description">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-12 mp0">
                <div class="row rowLeftM">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero common-leftbar">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Email resume at:</h4>
                                </div>
                                <a href="mailto:sales@propira.com ">sales@propira.com</a>
                                <p>PDF/DOCX only</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		</div>
    </div>
</div>
